import { render, staticRenderFns } from "./EmailConfiguration.vue?vue&type=template&id=0eed2cdb"
import script from "./EmailConfiguration.vue?vue&type=script&lang=js"
export * from "./EmailConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eed2cdb')) {
      api.createRecord('0eed2cdb', component.options)
    } else {
      api.reload('0eed2cdb', component.options)
    }
    module.hot.accept("./EmailConfiguration.vue?vue&type=template&id=0eed2cdb", function () {
      api.rerender('0eed2cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/EmailConfiguration.vue"
export default component.exports